import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getControlTask } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_TASKS.GET,
  api: getControlTask,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/controlTasks/GetAction.js